import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=e1e00fe6&scoped=true&"
import script from "./Collapse.vue?vue&type=script&lang=js&"
export * from "./Collapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e00fe6",
  null
  
)

export default component.exports